import xhr from 'live/services/xhr'
import PressureTestsUtils from 'plugin-pressuretests/shared/pressure_tests/pressure_tests_utils'

const URL = '/services/plugin-petrobras/sisp'

let defaultErrorCallback = function (resp, errorCallback) {
    let errorResponse = resp

    if (errorResponse.data) {
        errorResponse = errorResponse.data

        if (errorResponse.message) errorResponse = errorResponse.message
        else if (errorResponse.error) errorResponse = errorResponse.error
    } else if (errorResponse.error) {
        errorResponse = errorResponse.error
    }

    console.error(errorResponse)

    if (errorCallback) errorCallback(errorResponse)
}

const api = {
    list(callback, errorCallback) {
        xhr.get(URL + '/list')
            .then(resp => {
                callback(resp.data)
            })
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    listWells(instanceQualifier, timestamp, wellName, callback, errorCallback) {
    var requestURL =
    URL + '/listWells?qualifier=' + encodeURIComponent(instanceQualifier) + '&timestamp=' + timestamp
    
    if (wellName && wellName.length > 0) requestURL += '&wellName=' + encodeURIComponent(wellName)
    
    xhr.get(requestURL)
    .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },
    
    getTestsByWidgetId(widgetId, count, end, name, showAll, callback, errorCallback) {
        const pressureTestURL = '/services/plugin-pressuretests/pressure_tests'
        let requestURL = pressureTestURL + `/listTestsByWidgetId?count=${count}&widgetId=${widgetId}&end=${end}`
        requestURL += `&showAllTests=${showAll}`
        if (name) {
            requestURL += `&name=${name}`
        }

        xhr.get(requestURL)
            .then(r => callback(r))
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    getTestsByAssetId(assetId, count, end, name, showAll, callback, errorCallback) {
        const pressureTestURL = '/services/plugin-pressuretests/lotfit'
        let requestURL = pressureTestURL + `/listTestsByAssetId?count=${count}&assetId=${assetId}&end=${end}`
        requestURL += `&showAllTests=${showAll}`
        if (name) {
            requestURL += `&name=${name}`
        }

        xhr.get(requestURL)
            .then(r => callback(r))
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },


    send(instanceQualifier, payload, callback, errorCallback) {
        xhr.post(URL + '/sendBOPTestToSISP?qualifier=' + encodeURIComponent(instanceQualifier), payload)
            .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },
    sendLotFit(instanceQualifier, payload, callback, errorCallback) {
        xhr.post(URL + '/sendLotFitToSISP?qualifier=' + encodeURIComponent(instanceQualifier), payload)
            .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
    },

    setAditionalInformation(event, callback, errorCallback) {
        const _event = { ...event, extra: PressureTestsUtils.parseExtra(event.extra) }

        xhr.post(`/services/plugin-pressuretests/pressure_tests/setAdditionalInformation`, {
            ...event,
            extra: PressureTestsUtils.parseExtra(event.extra)
        })
            .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
            .catch(console.error)
    },

    setLotFitAditionalInformation(event, callback, errorCallback) {
        xhr.post(`/services/plugin-pressuretests/lotfit/setAdditionalInformation`, event)
            .then(callback)
            .fail(function (resp) {
                defaultErrorCallback(resp, errorCallback)
            })
            .catch(console.error)
    }
}

export default api
